<template>
  <b-taginput
    :data="filteredModules"
    :placeholder="$t('compSuperadminSettingsActiveModules.label')"
    :allow-new="false"
    v-model="buffer"
    :open-on-focus="true"
    ref="activeModulesInput"
    @input="inputChanged"
    rounded
    icon="caret-right"
    @typing="getFilteredModules"
    autocomplete
  >
    <template slot-scope="props">
      <b-icon :icon="getIcon(props.option)" /> &nbsp;
      {{ $t(props.option.name) }}
    </template>
    <template #selected="props">
      <b-tag
        v-for="(tag, index) in props.tags"
        :key="index"
        rounded
        :tabstop="false"
        ellipsis
        closable
        @close="updateTags(index, $event)"
      >
        <b-icon :icon="getIcon(tag)" /> &nbsp; {{ $t(tag.name) }}
      </b-tag>
    </template>
  </b-taginput>
</template>

<script>
import Modules from '@/models/Modules.js'
import { ALL_MODULES } from '@/models/ActiveModules'

export default {
  name: 'ActiveModules',
  inject: ['$validator'],
  props: {
    value: Array
  },
  data () {
    return {
      buffer: [],
      filteredModules: ALL_MODULES
    }
  },
  computed: {
    availableModules: function () {
      return ALL_MODULES
    }
  },
  methods: {
    getIcon: function (module) {
      return Modules.getIcon(module.type)
    },
    updateTags (index, event) {
      this.$refs.activeModulesInput.removeTag(index, event)
      this.inputChanged()
    },
    inputChanged () {
      this.$emit(
        'input',
        this.buffer.map((b) => b.name)
      )
    },
    getFilteredModules (text) {
      this.filteredModules = this.availableModules.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        )
      })
    }
  },
  mounted () {
    this.buffer = this.availableModules.filter((option) =>
      this.value.includes(option.name)
    )
  }
}
</script>
